import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56cd2827"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal_window"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_txt" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"225px","margin-top":"102px","margin-left":"62.5px"} }, "Для корректного формирования документа нужно заполнить все обязательные поля")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"248px","text-align":"center","margin-left":"51px","line-height":"0px","margin-top":"27px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "Пожалуйста, заполните подсвеченные поля на текущем шаге создания заявления")
], -1))
const _hoisted_4 = { class: "wrapper_btn" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"16px","display":"inline-block"} }, null, -1))
const _hoisted_6 = { class: "unskip" }
const _hoisted_7 = {
  key: 1,
  class: "modal_block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, "✖"),
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "do_btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.do_btn && _ctx.do_btn(...args)))
            }, "Заполнить"),
            _hoisted_5,
            _createElementVNode("button", {
              class: "skip_btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.skip_btn && _ctx.skip_btn(...args)))
            }, "Пропустить")
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createVNode(_component_v_switch, {
              style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
              color: "#2F80ED",
              modelValue: _ctx.unstep,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.unstep) = $event)),
              label: "Не показывать предупреждение в будущем",
              inline: "",
              onChange: _ctx.change_btn
            }, null, 8, ["modelValue", "onChange"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true)
  ], 64))
}